var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_3485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.8125C24.2451 20.8125 28.9062 16.1514 28.9062 10.4062C28.9062 4.66113 24.2451 0 18.5 0C12.7549 0 8.09375 4.66113 8.09375 10.4062C8.09375 16.1514 12.7549 20.8125 18.5 20.8125ZM27.75 23.125H23.7682C22.1639 23.8621 20.3789 24.2812 18.5 24.2812C16.6211 24.2812 14.8434 23.8621 13.2318 23.125H9.25C4.14082 23.125 0 27.2658 0 32.375V33.5312C0 35.4463 1.55371 37 3.46875 37H33.5312C35.4463 37 37 35.4463 37 33.5312V32.375C37 27.2658 32.8592 23.125 27.75 23.125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_3485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAlt);
export default __webpack_public_path__ + "static/media/user-alt.d521ca82cb2da08d452a55241096d6b7.svg";
export { ForwardRef as ReactComponent };